import { render, staticRenderFns } from "./CentralContas.vue?vue&type=template&id=6c1f6c53&"
import script from "./CentralContas.vue?vue&type=script&lang=js&"
export * from "./CentralContas.vue?vue&type=script&lang=js&"
import style0 from "./CentralContas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports